(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsController", SavingsController);

    /** @ngInject */
    function SavingsController($scope, $state, $timeout, $translate, SavingsViewModel, savingsActions, userGroupActions, dialogsService) {
        var vm = this;

        // Tab management
        vm.selectedTabIndex = 0;

        // Users tab
        vm.savings = new SavingsViewModel();
        vm.isLoading = false;
        vm.savingsUsers = [];
        vm.searchFilter = '';
        vm.savingsForPrint = [];

        // Groups tab
        vm.isLoadingGroups = false;
        vm.savingsGroups = [];
        vm.groupSearchFilter = '';

        // Users tab functions
        vm.filterSavings = filterSavings;
        vm.printSavings = printSavings;
        vm.deactivateSavings = deactivateSavings;
        vm.pageChanged = pageChanged;
        vm.sortChanged = sortChanged;

        // Groups tab functions
        vm.onTabChange = onTabChange;
        vm.filterGroups = filterGroups;
        vm.editGroup = editGroup;
        vm.createGroup = createGroup;

        // Initialize
        activate();

        function activate() {
            getSavingsUsers();
        }

        function onTabChange(tabIndex) {
            vm.selectedTabIndex = tabIndex;
            if (tabIndex === 1 && vm.savingsGroups.length === 0) {
                getSavingsGroups();
            }
        }

        // Users functions
        function getSavingsUsers() {
            vm.isLoading = true;
            savingsActions.getSavingsUsers(
                vm.savings.page,
                vm.savings.pageSize,
                vm.savings.orderBy,
                vm.savings.order,
                vm.searchFilter
            ).then(function (data) {
                vm.savingsUsers = data.content || [];
                vm.savings.total = data.totalElements || 0;
                vm.isLoading = false;
            }).catch(function (error) {
                vm.isLoading = false;
                console.error('Error loading savings users:', error);
            });
        }

        function filterSavings() {
            vm.savings.page = 1;
            getSavingsUsers();
        }

        function pageChanged(page, limit) {
            vm.savings.paginationChanged(page, limit);
            getSavingsUsers();
        }

        function sortChanged(order) {
            vm.savings.sortChanged(order);
            getSavingsUsers();
        }

        function printSavings(savingsUser) {
            vm.savingsForPrint = [savingsUser];
            $timeout(function () {
                window.print();
            }, 100);
        }

        function deactivateSavings(savingsUser) {
            dialogsService.showConfirmDialog(
                $translate.instant('SAVINGS_DEACTIVATE_TITLE'),
                $translate.instant('SAVINGS_DEACTIVATE_MESSAGE'),
                $translate.instant('YES'),
                $translate.instant('NO')
            ).then(function () {
                savingsActions.deactivateSavingsAccount(savingsUser.accountId).then(function () {
                    getSavingsUsers();
                }).catch(function (error) {
                    console.error('Error deactivating savings account:', error);
                });
            });
        }

        // Groups functions
        function getSavingsGroups() {
            vm.isLoadingGroups = true;
            userGroupActions.getUserGroups().then(function (data) {
                // Filter only SAVINGS type groups
                var allGroups = data || [];
                vm.savingsGroups = allGroups.filter(function (group) {
                    return group.groupType === 'SAVINGS';
                });
                vm.isLoadingGroups = false;
            }).catch(function (error) {
                vm.isLoadingGroups = false;
                console.error('Error loading savings groups:', error);
            });
        }

        function filterGroups() {
            if (!vm.groupSearchFilter) {
                getSavingsGroups();
                return;
            }
            var filter = vm.groupSearchFilter.toLowerCase();
            userGroupActions.getUserGroups().then(function (data) {
                var allGroups = data || [];
                vm.savingsGroups = allGroups.filter(function (group) {
                    return group.groupType === 'SAVINGS' && 
                           (group.name.toLowerCase().indexOf(filter) !== -1 ||
                            (group.description && group.description.toLowerCase().indexOf(filter) !== -1));
                });
            });
        }

        function editGroup(group) {
            $state.go('app.createUpdateUserGroup', { groupId: group.id });
        }

        function createGroup() {
            $state.go('app.createUpdateUserGroup', { groupId: null, groupType: 'SAVINGS' });
        }
    }
})();
